import React from 'react';
import type NextGenReportsOverviewType from '@atlassian/jira-spa-apps-next-gen-reports-overview/src/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { getBoardId } from '../../../../common/index.tsx';

/** @deprecated delete when cleaning up fun-1599-migrate-software-reports-route-entrypoint */
export const LazyNextGenReportsOverview = lazyForPaint<typeof NextGenReportsOverviewType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-next-gen-reports-overview", jiraSpaEntry: "next-gen-reports-overview" */ '@atlassian/jira-spa-apps-next-gen-reports-overview/src/index-old.tsx'
		),
	),
);

type Props = RouteContext;

/** @deprecated delete when cleaning up fun-1599-migrate-software-reports-route-entrypoint */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ location, match }: Props) => (
	<LazyPage
		Page={LazyNextGenReportsOverview}
		pageId={`next-gen-reports-overview-${getBoardId({ location, match })}`}
		shouldShowSpinner={false}
	/>
);
